import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { numberFormatter } from '../../utils/utils';

function getEventsMoreThanOne(
    numberOfEventsAsNumber: number,
    timeframeInMonthsAsNumber: number,
) {
    if (timeframeInMonthsAsNumber > 1 && timeframeInMonthsAsNumber <= 11) {
        return (
            <>
                <span> {numberFormatter(numberOfEventsAsNumber)}</span>{' '}
                {gettext('events in last')}{' '}
                {timeframeInMonthsAsNumber === 1
                    ? gettext('month')
                    : timeframeInMonthsAsNumber}{' '}
                {gettext('months')}
            </>
        );
    }
    if (timeframeInMonthsAsNumber >= 12 && timeframeInMonthsAsNumber <= 24) {
        return (
            <>
                <span> {numberFormatter(numberOfEventsAsNumber)}</span>{' '}
                {gettext('events in')}{' '}
                {timeframeInMonthsAsNumber >= 12 &&
                timeframeInMonthsAsNumber <= 18
                    ? gettext('1 year')
                    : gettext('2 years')}
            </>
        );
    }
    if (timeframeInMonthsAsNumber === 0) {
        return (
            <>
                <span>{numberFormatter(numberOfEventsAsNumber)}</span>{' '}
                {gettext('events in last month')}
            </>
        );
    }
}

export function getTrustSignalText(
    numberOfEventsAsNumber: number,
    timeframeInMonthsAsNumber: number,
) {
    if (numberOfEventsAsNumber === 1) {
        return <>{gettext('New to Eventbrite')}</>;
    }
    if (numberOfEventsAsNumber > 1) {
        return getEventsMoreThanOne(
            numberOfEventsAsNumber,
            timeframeInMonthsAsNumber,
        );
    }

    return null;
}

export function removeHtmlTags(input: string) {
    const textWithoutHtml = input.replace(/<[^>]*>/g, '');
    return textWithoutHtml.replace(/\s+/g, ' ').trim();
}

export const calculateTopOffset = () => {
    let isMobile = false;
    if (typeof window !== 'undefined') {
        isMobile = window?.innerWidth <= 768;
    }
    return isMobile;
};
